export const enum commonConstants  {
  
  //toast Message
  showMessageRequest = "SHOW_MESSAGE_REQUEST",
  showMessageSuccess = "SHOW_MESSAGE_SUCCESS",
  showMessageFailure = "SHOW_MESSAGE_FAILURE",
  clearMessage = "CLEAR_MESSAGE",

  //Get Service
  getServiceRequest = "GET_SERVICE_REQUEST",
  getServiceSuccess = "GET_SERVICE_SUCCESS",
  getServiceFailure = "GET_SERVICE_FAILURE",

  //Create Service
  createServiceRequest = "CREATE_SERVICE_REQUEST",
  createServiceSuccess = "CREATE_SERVICE_SUCCESS",
  createServiceFailure = "CREATE_SERVICE_FAILURE",

  //Delete Service
  deleteServiceRequest = "DELETE_SERVICE_REQUEST",
  deleteServiceSuccess = "DELETE_SERVICE_SUCCESS",
  deleteServiceFailure = "DELETE_SERVICE_FAILURE",

  //Get Service Params
  getServiceParamsRequest = "GET_SERVICE_PARAMS_REQUEST",
  getServiceParamsSuccess = "GET_SERVICE_PARAMS_SUCCESS",
  getServiceParamsFailure = "GET_SERVICE_PARAMS_FAILURE",


  serviceToggleRequest = "SERVICE_TOGGLE_REQUEST",
  serviceToggleSuccess = "SERVICE_TOGGLE_SUCCESS",
  serviceToggleFailure = "SERVICE_TOGGLE_FAILURE",

   //Get Service
  serviceViewRequest = "SERVICE_VIEW_REQUEST",
  serviceViewSuccess = "SERVICE_VIEW_SUCCESS",
  serviceViewFailure = "SERVICE_VIEW_FAILURE",

  // File delete (bulk)
  fileDeleteRequest = "FILE_DELETE_REQUEST",
  fileDeleteSuccess = "FILE_DELETE_SUCCESS",
  fileDeleteFailure = "FILE_DELETE_FAILURE",

  contactEmailRequest = "CONTACT_EMAIL_REQUEST",
  contactEmailSuccess = "CONTACT_EMAIL_SUCCESS",
  contactEmailFailure = "CONTACT_EMAIL_FAILURE",

  fileUploadUserRequest = "FILE_UPLOAD_USER_REQUEST",
  fileUploadUserSuccess = "FILE_UPLOAD_USER_SUCCESS",
  fileUploadUserFailure = "FILE_UPLOAD_USER_FAILURE",

  // ...existing constants...
  getPrivacyPolicyRequest = "GET_PRIVACY_POLICY_REQUEST",
  getPrivacyPolicySuccess= "GET_PRIVACY_POLICY_SUCCESS",
  getPrivacyPolicyFailure= "GET_PRIVACY_POLICY_FAILURE",

  getTermsOfServiceRequest= "GET_TERMS_OF_SERVICE_REQUEST",
  getTermsOfServiceSuccess= "GET_TERMS_OF_SERVICE_SUCCESS",
  getTermsOfServiceFailure= "GET_TERMS_OF_SERVICE_FAILURE",

};